
import { defineComponent } from "vue";
import PopupNotification from "./components/PopupNotification.vue";
import AuthModal from "./components/modals/AuthModal.vue";
import MobileFiltersModal from "./components/modals/MobileFiltersModal.vue";
import SignUpReportLoadingModal from "./components/modals/SignUpReportLoadingModal.vue";
import SignUpReportSuccessModal from "./components/modals/SignUpReportSuccessModal.vue";
import SignUpReportFailureModal from "./components/modals/SignUpReportFailureModal.vue";
import SignUpReportCustomerModal from "./components/modals/SignUpReportCustomerModal.vue";
import SignUpReportCancelledModal from "./components/modals/SignUpReportCancelledModal.vue";
import SetupTariffsModal from "./components/modals/SetupTariffsModal.vue";
import { mapGetters } from "vuex";

export default defineComponent({
  components: {
    PopupNotification,
    AuthModal,
    MobileFiltersModal,
    SignUpReportLoadingModal,
    SignUpReportSuccessModal,
    SignUpReportFailureModal,
    SignUpReportCustomerModal,
    SignUpReportCancelledModal,
    SetupTariffsModal,
  },
  computed: {
    ...mapGetters(['getLanguage'])
  },
  methods: {
    getHtmlLang(lang: string) {
      return lang === "ru" ? "ru" : lang === "en" ? "en" : "uz-Cyrl";
    }
  },
  watch: {
    "$i18n.locale"(newLang) {
      document.documentElement.lang = this.getHtmlLang(newLang);
    }
  },
  created() {
    this.$store.dispatch("autoLogin");
    this.$store.dispatch("autoTariffData");
    this.$store.dispatch("autoLanguage");
    this.$i18n.locale = this.getLanguage;
    document.documentElement.lang = this.getHtmlLang(this.$i18n.locale);
  },
});
